<template>
  <div>
    <el-dialog
      title="设置短信内容"
      :visible.sync="showDialog"
      width="70%"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :before-close="cancelAction"
    >
      <div>
        <div>
          <span>内容插入&nbsp;&nbsp;&nbsp;&nbsp;</span>
          <el-button
            v-for="(item, index) in textArray"
            :key="index"
            type="primary"
            plain
            @click="handleAdd(item.id)"
            >
{{ item.content }}
</el-button>
        </div>
        <br>
        <div>
          <el-input
v-model="text"
type="textarea"
placeholder="请输入内容"
/>
        </div>
      </div>
      <br>

      <div class="footer">
        <el-button @click="cancelAction">
取消
</el-button>
        <el-button
type="primary"
@click="handleConfirm"
>
确定
</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'SetText',
  props: {
    setTextVisible: {
      type: Boolean,
      default: false
    },
    setTextData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      text: '',
      textArray: [
        { id: 2, content: '活动名称' },
        { id: 3, content: '活动链接' }
      ]
    }
  },
  computed: {
    showDialog () {
      return this.setTextVisible
    }
  },
  watch: {
    showDialog (newVal, oldVal) {
      if (newVal) {
        if (this.setTextData[1]) {
          this.text = this.setTextData[1]
        } else {
          this.text = ''
        }
      } else {
        console.log(this.subTaskForm)
      }
    }
  },
  created () {},
  methods: {
    // 关闭模态框
    cancelAction () {
      this.$emit('setTextVisibleChange', [false])
    },
    handleConfirm () {
      let params = this.text
      this.$emit('setTextVisibleChange', [false, params])
    },
    handleAdd (val) {
      console.log(val)
      let result = this.textArray.filter((v) => {
        return v.id === val
      })
      this.text = this.text + '{{' + result[0].content + '}}'
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  justify-content: flex-end;
}
</style>
